import React, { useState } from 'react';

import { RowButton, SmallButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';
import { ErrorLabel, Label } from '@eika/label';

import useTranslation from '../../../hooks/useTranslation';
import { EikaModal } from '../../EikaModal';
import { StickyFooterRow } from '../../shared/StickyFooter';
import BicInput from './Receiver/BicInput';
import useFormContext from './form/useFormContext';

import './BicField.scss';

interface Props {
    label: string;
    error?: string;
    setError?: (value: undefined) => void;
}
const BicField: React.FC<Props> = ({ label, error, setError }) => {
    const translated = useTranslation();
    const { state } = useFormContext();
    const [showModal, setShowModal] = useState(false);
    const bic = state.receiver?.bic?.value;

    const openModal = (show: boolean) => {
        setShowModal(show);
        if (bic) {
            setError?.(undefined);
        }
    };

    return (
        <>
            <RowButton onClick={() => openModal(true)}>
                <div className="bic-field__layout">
                    <div className="bic-field__label">
                        <span className="bic-field__label">{label}</span>
                        <span className="bic-field__value">{bic ?? translated.crossBorderPayment.addBic}</span>
                    </div>
                    <div className="bic-field__icon">
                        <Icon type={IconTypes.LITEN_PIL_HOEYRE} className="icon--20" ariaLabel="Endre" />
                    </div>
                    {error ? (
                        <ErrorLabel className="bic-field__error-label" text={error} />
                    ) : (
                        <Label
                            className="bic-field__default-label"
                            text={translated.crossBorderPayment.requiredBicMessage}
                        />
                    )}
                </div>
            </RowButton>
            <EikaModal id="bicField" open={showModal} setOpen={openModal} title={translated.crossBorderPayment.addBic}>
                <div className="bic-field__input">
                    <BicInput enableValidation />
                </div>
                <StickyFooterRow>
                    <SmallButton onClick={() => openModal(false)}>{translated.continue}</SmallButton>
                </StickyFooterRow>
            </EikaModal>
        </>
    );
};

export default BicField;
